// 📄 components/layout/TareasBell.tsx
// Campanita de tareas del navbar — todas mis tareas vencidas/por vencer en
// cualquier proyecto (ver useTareasPendientesGlobal.ts), con un dropdown
// que linkea directo a cada una. Mismo patrón de click-outside que
// UserMenu.tsx.
import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Bell, Calendar } from 'lucide-react';
import { useTareasPendientesGlobal } from '../../hooks/useTareasPendientesGlobal.ts';
import { estaVencida } from '../../services/tareaService.ts';

export default function TareasBell() {
  const tareas = useTareasPendientesGlobal();
  const [open, setOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (containerRef.current && !containerRef.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  if (tareas.length === 0) return null;

  const irATarea = (projectId: string) => {
    setOpen(false);
    navigate(`/proyecto/${projectId}/tareas`);
  };

  return (
    <div className="relative" ref={containerRef}>
      <button
        onClick={() => setOpen((prev) => !prev)}
        title="Tareas por vencer"
        className="relative p-1.5 rounded-lg text-gray-300 hover:text-blue-400 transition-colors"
      >
        <Bell className="w-5 h-5" />
        <span className="absolute -top-0.5 -right-0.5 flex items-center justify-center min-w-[16px] h-4 px-1 rounded-full bg-red-500 text-white text-[10px] font-bold leading-none">
          {tareas.length > 9 ? '9+' : tareas.length}
        </span>
      </button>

      {open && (
        <div className="absolute right-0 mt-2 w-80 bg-[rgb(var(--c-surface))] border border-white/10 rounded-2xl shadow-2xl z-50 max-h-96 overflow-y-auto">
          <div className="p-3 border-b border-white/10">
            <p className="text-xs font-semibold text-gray-300">Tareas por vencer</p>
          </div>
          {tareas.map((t) => {
            const vencida = estaVencida(t);
            return (
              <button
                key={`${t.projectId}_${t.id}`}
                onClick={() => irATarea(t.projectId)}
                className="w-full text-left px-4 py-3 border-b border-white/5 hover:bg-white/5 transition-colors"
              >
                <p className="text-sm text-white truncate">{t.titulo}</p>
                <div className="flex items-center gap-2 mt-1 text-xs">
                  <span className={`flex items-center gap-1 ${vencida ? 'text-red-400' : 'text-amber-400'}`}>
                    <Calendar className="w-3 h-3" /> {t.fechaLimite}{vencida ? ' · Vencida' : ''}
                  </span>
                  <span className="text-gray-500 truncate">{t.proyectoNombre}</span>
                </div>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
